module.exports = require("@ember/routing");